import { render, staticRenderFns } from "./rule_config.vue?vue&type=template&id=fb59e236&scoped=true"
import script from "./rule_config.vue?vue&type=script&lang=js"
export * from "./rule_config.vue?vue&type=script&lang=js"
import style0 from "./rule_config.vue?vue&type=style&index=0&id=fb59e236&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb59e236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb59e236')) {
      api.createRecord('fb59e236', component.options)
    } else {
      api.reload('fb59e236', component.options)
    }
    module.hot.accept("./rule_config.vue?vue&type=template&id=fb59e236&scoped=true", function () {
      api.rerender('fb59e236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/configuration_list/form/add/components/rule_config.vue"
export default component.exports